import React, { Component, Fragment } from "react";
import Actions from "modules/auth/auth-actions";
import { connect } from "react-redux";
import { validateSsn } from "../utils/validations";
import { FormattedMessage } from "react-intl";
import { reduxForm } from "redux-form";
import PropTypes from "prop-types";
import FormattedMessageHtml from "modules/i18n/formatted-message-html";
import bankIdImage from "../assets/bankId.jpg";
import QRCode from "react-qr-code";

export const FORM_NAME = "bank-id";

class BankIdLoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      qrCodes: [],
      currentQR: null,
      autoStartToken: ""
    };
    this.qrInterval = null;
  }

  static propTypes = {
    handleSubmit: PropTypes.func,
    getSsnKey: PropTypes.func.isRequired
  };

  componentDidMount() {
    this.qrInterval = setInterval(() => {
      const now = new Date().getTime();
      const activeQR = this.state.qrCodes.find(qr => {
        const showTime = qr.show_at;
        return now >= showTime && now < showTime + 1000;
      });

      if (activeQR && activeQR.qr_payload !== this.state.currentQR) {
        this.setState({ currentQR: activeQR.qr_payload });
      }
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.qrInterval);
  }

  handleFormSubmit(values) {
    const { getSsnKey } = this.props;
    const setLoader = this.setLoaderActivity.bind(this);
    const updateQR = newCodes => {
      this.setState(prevState => ({
        qrCodes: [...prevState.qrCodes, ...newCodes]
      }));
    };

    const setToken = token => {
      this.setState(() => ({
        autoStartToken: token
      }));
    };

    setLoader(true);
    getSsnKey(values, setLoader, updateQR, setToken);
  }

  setLoaderActivity(loading) {
    this.setState({ loading });
  }

  render() {
    const { handleSubmit } = this.props;
    const { loading, currentQR, autoStartToken } = this.state;
    return (
      <div className="bank-id">
        <div className="bank-id-button-wrapper">
          {currentQR ? (
            <div className="qr-code__wrapper">
              <h3>
                <FormattedMessage id="root.identify-bank-id" />
              </h3>
              <p>
                <FormattedMessage id="root.identify-bank-id--description" />
              </p>
              <div>
                <QRCode value={currentQR} size={180} />
              </div>
              <a
                href={`bankid:///?autostarttoken=${autoStartToken}&redirect=${window.location.host
                  }`}
                target="_blank"
              >
                <FormattedMessage id="root.open-bank-id--device" />
              </a>
            </div>
          ) : (
            <form
              className="bank-id__form"
              onSubmit={handleSubmit(values => this.handleFormSubmit(values))}
            >
              {/*               <NumberFieldCmp
                name="ssn"
                placeholder={"root.social-security-number"}
                required
                customClass="bank-id-input"
                disabled={loading}
              /> */}
              <button
                className="bank-id__submit"
                type="submit"
                disabled={loading}
              >
                <div className="left-side">
                  {loading ? (
                    <Fragment>
                      <p className="bold">
                        <FormattedMessage id="root.loading" />
                      </p>
                      <FormattedMessageHtml
                        className="small-font"
                        element="p"
                        id="root.check_your_device"
                      />
                    </Fragment>
                  ) : (
                    <Fragment>
                      <p className="bold">
                        <FormattedMessage id="root.start-diagnosis" />
                      </p>
                      <p>
                        <FormattedMessage id="root.start-bank-id" />
                      </p>
                    </Fragment>
                  )}
                </div>
                <img src={bankIdImage} alt="" />
              </button>
            </form>
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  getSsnKey: Actions.Creators.getSsnKey
};

BankIdLoginForm = connect(
  null,
  mapDispatchToProps
)(BankIdLoginForm);

export default reduxForm({
  form: FORM_NAME,
  validate: validateSsn,
  destroyOnUnmount: false
})(BankIdLoginForm);



// WEBPACK FOOTER //
// ./src/modules/general-info/bankid-login-form.js